import { OPERATION_TYPE, MOVEABLE_INDICATORS } from "./constants.js";
export default class MoveableHistoryManager {
  constructor() {
    this.reset();
  }
  setMoveable(moveable, saveLast, operationType = this.operationType.transform) {
    if (this.isProcessingLocked || !saveLast) return;
    const newMoveable = { ...moveable, operationType: operationType }
    const shouldAddToHistory = !this.historyMoveables.length ||
      this.isNotSame(moveable, this.historyMoveables[this.historyMoveables.length - 1]);
    if (shouldAddToHistory) {
      this.historyMoveables.push(newMoveable);
    }
    this.setProcessingState(true);
  }
  setCopyMoveable(element) {
    this.copyMoveable = {
      ...element,
      attrList: { ...element.attrList }
    };
  }
  getCopyMoveable() {
    return this.copyMoveable;
  }
  getPreviousMoveable(isProcessingLocked = false) {
    this.setProcessingState(isProcessingLocked);
    return this.historyMoveables.length > 1 ? this.historyMoveables[this.historyMoveables.length - 2] : null;
  }
  getCurrentMoveable(isProcessingLocked = false) {
    this.setProcessingState(isProcessingLocked);
    return this.historyMoveables.length ? this.historyMoveables[this.historyMoveables.length - 1] : null;
  }
  getUndoMoveable(isProcessingLocked = false) {
    this.setProcessingState(isProcessingLocked);
    if (!this.historyMoveables?.length) return null;

    const previousMoveable = this.historyMoveables.pop();
    this.rollbackMoveables.push(previousMoveable);

    return previousMoveable;
  }
  getRedoMoveable(isProcessingLocked = false) {
    this.setProcessingState(isProcessingLocked);
    if (!this.rollbackMoveables?.length) return null;

    const rollbackMoveable = this.rollbackMoveables.pop();
    this.historyMoveables.push(rollbackMoveable);

    return rollbackMoveable;
  }
  setProcessingState(isProcessingLocked) {
    this.isProcessingLocked = isProcessingLocked;
    this.delayForRollback();
  }
  delayForRollback() {
    if (!this.isProcessingLocked) return;
    setTimeout(() => {
      this.isProcessingLocked = false;
    }, 150);
  }
  reset() {
    this.operationType = OPERATION_TYPE;
    this.historyMoveables = [];
    this.rollbackMoveables = []
    this.isProcessingLocked = false;
    this.copyMoveable = null;
  }
  clearHistoryMoveable(element) {
    if (!element.id) return;
    const filterByElementId = item => element.id !== item.id;
    this.rollbackMoveables = this.rollbackMoveables.filter(filterByElementId);
    this.historyMoveables = this.historyMoveables.filter(filterByElementId);
  }
  isNotSame(a, b) {
    if (!a || !b) return true;
    
  //  const properties = ['id', 'x', 'y', 'width', 'height', 'operationType'];
    return MOVEABLE_INDICATORS.some(property =>
      a[property] !== b[property]
    );
  }
}
